import React, { Component } from 'react';
import $ from 'jquery';
import loadScript from 'simple-load-script';

class ImportScripts extends Component {
  componentDidMount() {
    window.$ = $;
    window.jQuery = $;
    loadScript('/js/bootstrap.min.js');
    import('owl.carousel')
      .then((module) => {
        // loadScript('/js/jquery-3.3.1.min.js');
        // loadScript('/js/owl.carousel.min.js');
        loadScript('/js/main-js.js?v=3');
        // loadScript('/js/multiple-carousel.js');
    });
  }

  render() {
    return <script />;
  }
}
export default ImportScripts;
